import StuMapListArea from "@/pages/comp/plan/study/study_map/common/stu_map/right/stu_map_list";

function StuMapWritePopup(props: any) {
  let myProps = {
    closePopup: () => { },
    callback_refresh_data: () => { },
    stu_seq:"",
    stu_info_arr: [],
    ...props
  };

  return (
    <div>
      <StuMapListArea
        list={myProps.callback_refresh_data}
        stu_seq={myProps.stu_seq}
        stu_info_arr={myProps.stu_info_arr}
      ></StuMapListArea>
    </div>
  );
};
export default StuMapWritePopup;